import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=282b194c&scoped=true&"
import script from "./tasks.vue?vue&type=script&lang=js&"
export * from "./tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b194c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('282b194c')) {
      api.createRecord('282b194c', component.options)
    } else {
      api.reload('282b194c', component.options)
    }
    module.hot.accept("./tasks.vue?vue&type=template&id=282b194c&scoped=true&", function () {
      api.rerender('282b194c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/maps/tasks.vue"
export default component.exports